<procure-input-select
  appendTo=".search-overlay"
  [multiple]="multiple()"
  [label]="label()"
  [control]="control()"
  [items]="selectOptions()"
  [maxVisible]="5"
/>
